document.addEventListener("turbo:load", lazyLoadImages)
document.addEventListener('turbo:frame-render', lazyLoadImages)

function lazyLoadImages() {
  document.querySelectorAll(".lazy-image:not(.loaded)").forEach((lazyImage) => {
    const img = lazyImage.querySelector("img")
    
    const loaded = () => {
      lazyImage.classList.add("loaded")
      lazyImage.removeAttribute("style")
    };

    if (img.complete) {
      loaded()
    } else {
      img.addEventListener("load", loaded)
    }
  });
}